(() => {
  'use strict';

  function updateHalloweenTopbar() {
    document.querySelectorAll('[data-halloween-bar]').forEach((bar) => {
      const cycleDays = Number(bar.getAttribute('data-cycle-days')) || 5;
      const cycleMs = cycleDays * 24 * 60 * 60 * 1000;
      const anchor = Date.parse(bar.getAttribute('data-cycle-anchor') || '');
      const now = Date.now();

      if (!Number.isFinite(anchor) || !Number.isFinite(cycleMs) || cycleMs <= 0) {
        bar.hidden = true;
        return;
      }

      const elapsed = now - anchor;
      const cycleNumber = elapsed < 0 ? 0 : Math.floor(elapsed / cycleMs) + 1;
      const cycleEnd = anchor + cycleNumber * cycleMs;
      const remainingSeconds = Math.max(1, Math.ceil((cycleEnd - now) / 1000));
      const values = {
        days: Math.floor(remainingSeconds / 86400),
        hours: Math.floor(remainingSeconds / 3600) % 24,
        minutes: Math.floor(remainingSeconds / 60) % 60
      };

      Object.entries(values).forEach(([unit, value]) => {
        const node = bar.querySelector(`[data-unit="${unit}"]`);
        if (node) node.textContent = String(value).padStart(2, '0');
      });

      const timer = bar.querySelector('[role="timer"]');
      if (timer) {
        timer.setAttribute(
          'aria-label',
          `${values.days} days, ${values.hours} hours and ${values.minutes} minutes remaining; this five-day offer timer repeats`
        );
      }
      bar.hidden = false;
    });
  }

  if (!window.ewHalloweenTopbarTimer) {
    window.ewHalloweenTopbarTimer = window.setInterval(updateHalloweenTopbar, 15000);
  }
  updateHalloweenTopbar();
  document.addEventListener('DOMContentLoaded', updateHalloweenTopbar);
  document.addEventListener('shopify:section:load', updateHalloweenTopbar);
  document.addEventListener('visibilitychange', updateHalloweenTopbar);
})();